module.exports = __webpack_public_path__ + "assets/images/profiles/1970-1-desktop.jpg?v=4b6e763e";